/* eslint-disable */
require('./admiral_1')
require('./admiral_2')
require('./admiral_3')
require('./admiral_4')
require('./agent')
require('./assassinate')
require('./conversion')
require('./cover')
require('./credit_1')
require('./credit_2')
require('./credit_3')
require('./credit_perc_1')
require('./credit_pola_1')
require('./credit_pop')
require('./defense_1')
require('./dominion_1')
require('./dominion_2')
require('./dominion_3')
require('./dominion_rate_1')
require('./dominion_rate_2')
require('./frame_doctrine')
require('./frame_lex')
require('./ideo_1')
require('./ideo_2')
require('./ideo_3')
require('./ideo_pola')
require('./infiltration')
require('./mobility_1')
require('./mobility_2')
require('./prod_1')
require('./prod_2')
require('./reduce_maintenance_1')
require('./reduce_maintenance_2')
require('./sabotage')
require('./speaker_1')
require('./speaker_2')
require('./speaker_3')
require('./speaker_4')
require('./speaker_dominion')
require('./spy_1')
require('./spy_2')
require('./spy_3')
require('./spy_4')
require('./spy_bonus')
require('./spy_def_1')
require('./spy_def_2')
require('./stab_1')
require('./stab_2')
require('./sys_dom_1')
require('./sys_dom_2')
require('./system_1')
require('./system_2')
require('./system_3')
require('./system_4')
require('./tech_1')
require('./tech_2')
require('./tech_3')
require('./tech_pola')
require('./upgrade_fleet')
require('./upgrade_invasion')
require('./upgrade_raid')
require('./upgrade_repair')
require('./upgrade_xp')
